import {Field, ErrorMessage} from 'formik';
import styled from 'styled-components';

import {
  TextFieldContainer,
  FieldMargin,
} from '../../_old/FieldHelpers/FieldContainers';
import {FormError} from '../../_old/FieldHelpers/FormError';
import {Label} from '../../_old/FieldHelpers/Label';
import {TEXTAREA_DEFAULT_MAX} from '../../utils/constants';

import {WordCount} from './WordCount';

import type {FieldInputProps, FieldProps} from 'formik';

export type TextareaInnerProps =
  React.InputHTMLAttributes<HTMLTextAreaElement> & {
    field: FieldInputProps<any>;
    setIsActive: (b: boolean) => void;
  };
export function TextareaInner({setIsActive, ...props}: TextareaInnerProps) {
  return (
    <StyledTextArea
      {...props.field}
      id={props.field.name}
      {...props}
      maxLength={props.maxLength ?? TEXTAREA_DEFAULT_MAX}
      onBlur={() => setIsActive(false)}
      onFocus={() => setIsActive(true)}
    />
  );
}
const StyledTextArea = styled.textarea`
  border: none;
  width: 100%;
  background-color: transparent;
  resize: vertical;
  min-height: 7rem;
  outline: 0;

  &:focus {
    outline: 0;
    border: 0;
    box-shadow: none;
  }
`;

export type TextareaFieldProps = {
  name: string;
  children: React.ReactNode;
  inputProps?: React.InputHTMLAttributes<HTMLTextAreaElement>;
};
export function TextareaField(props: TextareaFieldProps) {
  return (
    <FieldMargin>
      <Field name={props.name}>
        {({field, meta}: FieldProps) => (
          <TextFieldContainer
            readOnly={props.inputProps?.readOnly ?? false}
            error={meta.error}
          >
            {(isActive: boolean, setIsActive: (b: boolean) => void) => (
              <>
                <Label
                  isActive={isActive}
                  readOnly={props.inputProps?.readOnly ?? false}
                  error={meta.error}
                  required={props.inputProps?.required ?? false}
                  htmlFor={field.name}
                >
                  {props.children}
                  <WordCount
                    count={field.value.length}
                    maxLength={props.inputProps?.maxLength}
                  />
                </Label>
                <TextareaInner
                  field={field}
                  setIsActive={setIsActive}
                  {...props.inputProps}
                />
              </>
            )}
          </TextFieldContainer>
        )}
      </Field>
      <ErrorMessage name={props.name} component={FormError} />
    </FieldMargin>
  );
}
export function TextareaField2(props: TextareaFieldProps) {
  return (
    <FieldMargin>
      <Field name={props.name}>
        {({field, meta}: FieldProps) => (
          <>
            <TextFieldContainer
              readOnly={props.inputProps?.readOnly ?? false}
              error={meta.error}
            >
              {(isActive: boolean, setIsActive: (b: boolean) => void) => (
                <>
                  <Label
                    isActive={isActive}
                    readOnly={props.inputProps?.readOnly ?? false}
                    error={meta.error}
                    required={props.inputProps?.required ?? false}
                    htmlFor={field.name}
                  >
                    {props.children}
                    <WordCount
                      count={field.value.length}
                      maxLength={props.inputProps?.maxLength}
                    />
                  </Label>
                  <TextareaInner
                    field={field}
                    setIsActive={setIsActive}
                    {...props.inputProps}
                  />
                </>
              )}
            </TextFieldContainer>

            {meta.error &&
              meta.touched &&
              // @ts-expect-error formik zod not sure idk
              meta.error._errors?.map((error) => (
                <FormError key={error}>{error}</FormError>
              ))}
          </>
        )}
      </Field>
    </FieldMargin>
  );
}
